"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _scales = _interopRequireDefault(require("./scales"));

var _default = {
  neutral: {
    lightest: _scales.default.neutral.N1,
    light: _scales.default.neutral.N4,
    base: _scales.default.neutral.N9,
    dark: _scales.default.neutral.N10
  },
  blue: {
    lightest: _scales.default.blue.B1,
    light: _scales.default.blue.B4,
    base: _scales.default.blue.B9,
    dark: _scales.default.blue.B10
  },
  red: {
    lightest: '#fef6f6',
    light: '#fae2e2',
    base: '#ec4c47',
    dark: '#bf0e08'
  },
  orange: {
    lightest: '#fdf8f3',
    light: '#fae3cd',
    base: '#d9822b',
    dark: '#95591e'
  },
  yellow: {
    lightest: '#fef8e7',
    light: '#fbe6a2',
    base: '#f7d154',
    dark: '#7e6514'
  },
  green: {
    lightest: '#f1faf5',
    light: '#d4eee2',
    base: '#47b881',
    dark: '#00783e'
  },
  teal: {
    lightest: '#f1fbfc',
    light: '#d2eef3',
    base: '#14b5d0',
    dark: '#007489'
  },
  purple: {
    lightest: '#f8f7fc',
    light: '#eae7f8',
    base: '#735dd0',
    dark: '#37248f'
  }
};
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/theme/src/default-theme/foundational-styles/palette.js
// module id = 29
// module chunks = 0